<template>
  <div>
    <div class="topPart">
      <img
        src="../assets/images/news.png"
        alt=""
      />
      <span>暂无最新消息</span>
    </div>
    <!--企业-->
    <div class="bottomPart">
      <div class="titlePart">征信授权</div>
      <el-divider />
      <el-form
        :inline="true"
        :model="submitForm"
        class="demo-form-inline formPart"
        label-position="top"
      >
        <div class="part">
          <div class="title">匹配信息</div>
          <el-form-item label="企业名称">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="企业证件代码">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="机构法人">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="法人证件类型">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="法人证件号">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="法人手机号">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
          <el-form-item label="基本开户行">
            <el-input
              v-model="submitForm.companyName"
              maxLength="20"
              placeholder="请输入"
            />
          </el-form-item>
        </div>
        <div class="part">
          <div class="title">补充信息</div>
          <el-form-item label="申请时间">
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              multiple
            >
              <i class="el-icon-plus"></i>
              <div class="el-upload__text">上传经营执照</div>
            </el-upload>
          </el-form-item>
        </div>
      </el-form>
      <el-divider />
      <div class="footPart">
        <div>
          <el-checkbox v-model="submitForm.isRead" /><span>我已阅读<a
              style="color: #2981EE;cursor: pointer"
            >征信APP实名认证协议</a></span>
        </div>
        <el-button @click="handleSubmit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      submitForm: {
        isRead: false,
      }
    }
  },
  methods: {
    handleSubmit () {
    }
  }
}
</script>

<style lang="less" scoped>
.topPart {
  width: 100%;
  display: flex;
  height: 40px;
  background: #fff;
  box-sizing: border-box;
  padding: 10px 20px;
  font-size: 14px;
  border-radius: 6px;
  align-items: center;
  img {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }
}
.bottomPart {
  width: 100%;
  min-height: 720px;
  background: #fff;
  box-sizing: border-box;
  padding: 20px 0;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
  }
  .formPart {
    display: flex;
    padding: 0 80px;
    .part {
      width: 50%;
      height: 100%;
      .title {
        color: #2a2a2a;
        font-size: 18px;
        font-weight: 550;
        position: relative;
        padding-left: 12px;
        &::before {
          content: "";
          position: absolute;
          width: 6px;
          height: 20px;
          background: #2981ee;
          top: 3px;
          left: 0;
        }
      }
    }
  }
  .el-divider {
    background-color: #f3f4f9;
  }
  .footPart {
    padding: 0 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    label {
      margin-right: 5px;
    }
    button {
      color: #fff;
      background: #2981ee;
      padding: 10px 30px;
      border: unset;
    }
  }
}
/deep/.el-form {
  .el-form-item {
    width: 100%;
    padding-right: 80px;
    box-sizing: border-box;
    .el-form-item__label {
      padding: 0;
    }
  }
}
</style>
